import { Environment } from "./environment.type";

export const environment: Environment = {
  production: false,
  backendUrl: 'https://staff.dev.themyersbriggs.com'
};
